import ApiService from "@/core/services/api.service";

/**
 * POST /api/v1/loans/transactions/transfer-repayment-to-savings
 * @param {{ transaction_id: number, savings_account_id?: number, notes?: string }} payload
 */
export function transferLoanRepaymentToSavings(payload) {
	return ApiService.post(
		"loans/transactions/transfer-repayment-to-savings",
		payload
	);
}
